import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Fútbol americano",
    Baseball: "Béisbol",
    Basketball: "Baloncesto",
    Boxing: "Boxeo",
    Chess: "Ajedrez",
    Cricket: "Críquet",
    Darts: "Dardos",
    Entertainment: "Entertainment",
    "E-Sports": "E-Sports",
    Football: "Fútbol",
    "Formula 1": "Fórmula 1",
    "Gaelic Football": "Fútbol Gaélico",
    "Generic Sport": "Generic Sport",
    Golf: "Golf",
    "Greyhound Racing": "Carreras de galgos",
    Handball: "Balonmano",
    "Ice Hockey": "Hockey sobre hielo",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Política",
    "Rugby League": "Liga de Rugby",
    "Rugby Union": "Rugby Union",
    Snooker: "Snooker",
    "Table Tennis": "Tenis de mesa",
    Tennis: "Tenis",
    "Virtual Football": "Virtual Football",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} ganar",
    WinFirstRound: "{name} ganar el primer asalto",
    FirstTouchdown: "{name} marcar el primer toughdown",
    FirstTry: "{name} marcar el primero ensayo",
    TotalGoals: "{name} Total de Goles",
    TotalRuns: "{name} Total de Runs",
    TotalPoints: "{name} Total de Puntos",
    TopBatsman: "{name} Mejor Batsman",
    TopBowler: "{name} Mejor Bowler",
    FirstScore: "{name} Mejor Bowler"
  },
  PromoTexts: {
    Pick: "Hagan sus apuestas",
    Bet: "Apostar",
    Pays: "Retiradara"
  },
  DateTimeTexts: {
    Today: "Hoy dia",
    Tomorrow: "Mañana",
    Live: "En vivo"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Hagan sus apuestas",
    Return: "Retiradara",
    Stake: "Apostar",
    Draw: "X"
  },
  H2HTexts: {
    "Goals scored": "Goles a favor",
    Shots: "Tiros",
    "Shots on target": "Tiros a puesta",
    "Ball possession": "Posesión",
    "Goals conceded": "Goles en contra",
    "Per match": "Por partido",
    H2H: "Enfrentamientos Directos",
    W: "V",
    D: "E",
    L: "D"
  }
};
